import { z } from 'zod'

// Stops filter enum
export const stopsFilterSchema = z.enum(['all', 'direct', 'one_stop_max', 'two_stops_max'])
export type StopsFilterValue = z.infer<typeof stopsFilterSchema>

// Luggage filter enum (minimum checked bags required)
export const luggageFilterSchema = z.enum(['none', '0', '1', '2'])
export type LuggageFilterValue = z.infer<typeof luggageFilterSchema>

// Flight results search params schema - directly embeds NewFlightSchema as JSON
export const flightResultsSearchSchema = z.object({
  // Filter state
  filterAirlines: z.string().optional(),
  filterDurationMax: z.coerce.number().optional(),
  filterDurationMin: z.coerce.number().optional(),
  filterLuggage: luggageFilterSchema.optional().default('0'),
  filterPriceMax: z.coerce.number().optional(),
  filterPriceMin: z.coerce.number().optional(),
  filterStops: stopsFilterSchema.optional().default('all'),
  filterTimeRanges: z.string().optional(),
  // Search criteria - parsed automatically by TanStack Router from JSON
  flightSearch: z.record(z.unknown()),
})
